import type { Currency, Locale } from '../stores/preferences.js';

export function formatPrice(cents: number, currency: Currency, locale: Locale): string {
  if (!Number.isFinite(cents)) return '—';
  const amount = cents / 100;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatCurrency(amount: number, currency: Currency, locale: Locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(date: Date | string, locale: Locale): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);
}

export function formatRelativeTime(date: Date | string, locale: Locale): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '—';
  const diffMs = d.getTime() - Date.now();
  const diffSeconds = Math.round(diffMs / 1000);
  const absDiffSeconds = Math.abs(diffSeconds);

  if (absDiffSeconds < 60) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(diffSeconds, 'second');
  }
  if (absDiffSeconds < 3600) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(
      Math.round(diffSeconds / 60),
      'minute',
    );
  }
  if (absDiffSeconds < 86400) {
    return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(
      Math.round(diffSeconds / 3600),
      'hour',
    );
  }
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(
    Math.round(diffSeconds / 86400),
    'day',
  );
}
